import { useTranslation } from 'react-i18next'
import {
  Wrapper,
  FullLogo,
  Block,
  Links,
  CopyRight
} from './styles'

// icons
import FullLogoSRC from 'assets/Logo/full.svg'

// components
import Socials from 'components/Socials'

export default function Footer() {

  const { t, i18n } = useTranslation()

  return (
    <Wrapper>

      <Block>
        <FullLogo src={FullLogoSRC} loading="lazy" style={{width: '11.4rem'}} />
        <CopyRight>&copy; Copyright {new Date().getFullYear()} {window.location.host}</CopyRight>
      </Block>
      <Links>
        <a target="_blank" href='/policy.pdf'>{t("footer.privacy")}</a>
        <a target="_blank" href='/terms.pdf'>{t("footer.terms")}</a>
      </Links>
      <Block>
        <Socials />
      </Block>

    </Wrapper>
  );
}